export enum ProjectName {
  Clearline = "clearline",
  Fanda = "fanda",
  Posmarketing = "posmarketing"
}
